import { useState, useEffect } from 'react';
import apiService from '../services/apiService'; // Centralized API service

const useBills = (currentPage = 1, currentPageLimit = 100, refreshKey) => {
  const [bills, setBills] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPageLimit, setTotalPagesLimit] = useState(100);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBills = async () => {
      setLoading(true);
      try {
        const response = await apiService.getBills(currentPage, currentPageLimit);
        // const { items, total_pages, limit } = response.data.total_pages;
        const { items, total_pages, limit } = response.data;
        setBills(items);
        setTotalPages(total_pages);
        setTotalPagesLimit(limit);
        setError(null);
      } catch (err) {
        console.error(err);
        setError(err.message || 'Error fetching bills');
      } finally {
        setLoading(false);
      }
    };
    fetchBills();
  }, [currentPage, currentPageLimit, refreshKey]);

  return { bills, totalPages, totalPageLimit, loading, error };
};

export default useBills;
